import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { TellentMemberBrief } from '@tellent-ask-hr/core-types';
import type { TellentNote } from '@tellent-ask-hr/notes-types';

import { getTellentNoteScope } from '../notes/notes.store';

const idSelector = (note: { guid: string }) => note.guid;
const { selectors, reducer, actions, namespace } =
  createEntityCollectionStore<TellentMemberBrief>()('TellentMentionables', {
    idSelector,
    customActions: adapter => {
      const _defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCollection: (
          state,
          payload: { resourceType: TellentNote['resourceType']; resourceId: number },
        ) =>
          adapter.markAsPending(state, {
            scope: getTellentNoteScope(payload.resourceType, payload.resourceId),
            entities: [],
          }),
      };
    },
  });

export {
  selectors as TellentMentionableSelectors,
  reducer as TellentMentionableReducer,
  actions as TellentMentionableActions,
  namespace as TellentMentionableNamespace,
};
